<template>
    <div data-component="AmsListItemFooter" class="flex items-center justify-between w-full">
        <img v-if="item.advertiserLogo" class="h-[28px]" :src="item.advertiserLogo" :alt="`${item.advertiser} logo`" />
        <div class="flex flex-col">
            <div v-if="item.price" class="ml-auto text-h3 font-bold-headline">
                {{ commonUtils.thousandSeparator(item.price) }} €
            </div>
            <ams-rating-lights
                v-if="hasPriceIndicator && isRatedItem"
                isTextLink
                hasText
                :priceClass="item.priceIndicator.priceClass"
                @click.stop="onClickPriceIndicator"
            />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { commonUtils } from '@sunrise/shared'
import { PropType } from 'vue'
import { AmsItem, UsageState } from '../../services/amsSearch/amsSearch.interface'
import AmsRatingLights from '../AmsPriceIndicator/AmsRatingLights'

const emit = defineEmits(['clickPriceIndicator'])

const props = defineProps({
    item: {
        type: Object as PropType<AmsItem>,
        required: true,
    },
    hasPriceIndicator: Boolean,
})

const isRatedItem = props.item.accidentFree && props.item.usageState !== UsageState.New

const onClickPriceIndicator = () => {
    emit('clickPriceIndicator')
}
</script>
